import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import { noop } from 'lodash';

import FavouriteItem from './FavouriteListItem';

export default function FavouriteList ({ favourites, onSelect, onDelete }) {

    return (
        <ul className="favourite-list">
            {favourites.map(favourite =>
                <FavouriteItem key={ favourite.id } favourite={ favourite } onSelect={ onSelect } onDelete={ onDelete }/>
            )}
        </ul>
    );
}

FavouriteList.propTypes = {
    favourites: PropTypes.instanceOf(List).isRequired,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func
};

FavouriteList.defaultProps = {
    favourites: new List(),
    onSelect: noop,
    onDelete: noop
};
